module.exports = __webpack_public_path__ + "media/images/flags/1x1/yem-7063c251c5fe7c3622950625555070ea.svg";